import React from "react";
import "../../../styles/EngSidebar.css";
import Logo from "../../../assets/logoWhite.png";
import data from "../Data/Data";
import { useParams, NavLink, Link } from "react-router-dom";
import parse from "html-react-parser";
import "../../../ReUseAbleComp/styles.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { GiHamburgerMenu } from "react-icons/gi";
import Tooltip from "@mui/material/Tooltip";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";

const LGEnglishDetails = ({
  ToggleSidebarOpen,
  ToggleSidebarIsopen,
  ToggleSidebar,
}) => {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [dataListObj, setDataListObj] = React.useState({});

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Divider />
    </Box>
  );
  const { Id } = useParams();
  React.useEffect(() => {
    function filterById(ids) {
      return data.filter((obj) => {
        return obj.id === ids;
      });
    }
    let dataList = filterById(parseInt(Id));
    setDataListObj(dataList[0]);
  }, [Id]);

  React.useEffect(() => {
    toast.info("Default Language Set To English", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      pauseOnHover: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined,
    });
  }, []);
  if (!dataListObj) return <div>Data Not Found</div>;
  return (
    <>
      <Helmet>
        <title>{dataListObj.title}</title>
      </Helmet>
      <ToastContainer />
      <div className="mix_lang_header">
        <Link to="/">
          <img src={Logo} alt="lang_header_logo" className="mix_lang_logo" />
        </Link>
        <div className="socialIcons">
          <NavLink
            className="urdu"
            to={`/CovidEngTopicsDetails/${Id}`}
            activeClassName="active-lang"
          >
            Eng
          </NavLink>
          <Link className="urdu" to={`/CovidUrduDetails/${Id}`}>
            اردو
          </Link>
          <Link className="urdu" to={`/CovidPashtoDetails/${Id}`}>
            pashto
          </Link>
        </div>
      </div>

      <div id="outer-container">
        <div id="sidebar">
          {data.map((list) => (
            <Tooltip title={list.title} arrow>
              <NavLink
                key={list.id}
                to={`/CovidEngTopicsDetails/${list.id}`}
                className="sidebar-btn"
                activeClassName="active-btn"
              >
                <span className="sidebar-btn-icon">{list.RID}</span>
                <span className="sidebar-btn-text">
                  {`${list.title.substring(0, 28)}..`}
                </span>
              </NavLink>
            </Tooltip>
          ))}
        </div>
        <div id="content">
          <h1 className="Sidebar_title">{dataListObj.title}</h1>
          <p className="Sidebar_desc">
            {" "}
            {typeof dataListObj.desc === "string" && parse(dataListObj.desc)}
          </p>
        </div>
      </div>

      <div className="ToggleSidebar">
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Drawer
              className="toggleSideBar"
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              <span
                className="ToggleBtnClose"
                onClick={toggleDrawer(anchor, false)}
              >
                X
              </span>
              {data.map((list) => (
                <Tooltip title={list.title} arrow>
                  <NavLink
                    key={list.id}
                    to={`/CovidEngTopicsDetails/${list.id}`}
                    onClick={toggleDrawer(anchor, false)}
                    className="sidebar-btn"
                    activeClassName="active-btn"
                  >
                    <span className="sidebar-btn-icon">{list.RID}</span>
                    <span className="sidebar-btn-text">
                      {`${list.title.substring(0, 25)}..`}
                    </span>
                  </NavLink>
                </Tooltip>
              ))}
            </Drawer>
            <span
              className="ToggleBtn posLeft"
              onClick={toggleDrawer(anchor, true)}
            >
              <GiHamburgerMenu />
            </span>
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default LGEnglishDetails;
